import {
  FETCH_USER_PROFILE_DATA,
  SAVE_USER_PROFILE_DATA,
  UPDATE_USER_PROFILE_DATA
  } from "../actions/types";

  const INITIAL_STATE = {
    userProfile: [],
  };

  export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_USER_PROFILE_DATA:
        return {
          ...state,
          userProfile: action.payload,
        };
      case SAVE_USER_PROFILE_DATA:
        return {
          ...state,
          userProfile:[...state.userProfile].concat(action.payload)
        };
      case UPDATE_USER_PROFILE_DATA:
        return {
          ...state,
          userProfile:[...state.userProfile].concat(action.payload)
        };
      default:
        return state;
    }
  };
  